import React, { useCallback } from "react";
import { RegistrationFormContextShape } from "../../../contexts/form";
import { useNavigate } from "react-router-dom";
import { PAGE_PATHS } from "../../page-paths";
import { useAuth } from "../../../utils/hooks/useAuth";
import { webappBaseUrl } from "../../../config";

export default function FormSuccess({
  formState,
  clearForm,
}: {
  formState: RegistrationFormContextShape["formState"];
  clearForm: RegistrationFormContextShape["clearForm"];
}) {
  const navigate = useNavigate();
  const {
    authState: { vle },
  } = useAuth();

  console.log("VLE", vle);

  const endOnboarding = useCallback(() => {
    clearForm();
    vle
      ? navigate(PAGE_PATHS.DEFAULT_NAVIGABLE)
      : (window.location.href = "https://candidate-iibf.cscacademy.org/");
  }, [vle]);

  return (
    <div className="flex flex-col items-center justify-center gap-y-4">
      <img
        src={require("../../../assets/success.gif")}
        className="h-32 m-auto"
        alt="success-gif"
      />
      <span className="text-2xl font-bold">Successfully Onboarded</span>
      <span className="text-2xl font-semibold">[{formState.name}]</span>
      <p className="text-center max-w-[400px] text-lg">
        {vle
          ? "The candidate has been successfully registered."
          : "Please check your registered email for login credentials and your invoice."}
      </p>
      <button onClick={endOnboarding} className="btn-primary w-full text-lg">
        {`Continue to ${vle ? "Dashboard" : "Learner Portal"}`}
      </button>
    </div>
  );
}
